import useEventListener from "./reactUtils/useEventListener";
import { CustomEventTypes } from "../globals";
import store, { StoreActions } from "../state/store";
import Utils from "../classes/Utilities";
import Scenario from "../classes/scenarioElements/Scenario";

export default function GlobalEventHandler() 
{
	// global actions for simulation start/stop
	useEventListener(CustomEventTypes.simulationStarted, ()=>
	{
		Utils.uiTemplateEditSaveChanges();
		store.dispatch(StoreActions.timeline.setCurrentFrame(0));
		store.dispatch(StoreActions.checklist.setCurrentNumberOfRetries(store.getState().checklistModule.quizSettings?.gradedAttempts ?? 0));
		store.dispatch(StoreActions.ui.setTempUiPreview(store.getState().uiModule.previewVisible));
		store.dispatch(StoreActions.ui.setUIPreviewVisible({ value: true }));
	}, document);

	useEventListener(CustomEventTypes.simulationStopped, ()=>
	{
		Scenario.clearSimulationSkips();
		store.dispatch(StoreActions.checklist.clearAnswers());
		store.dispatch(StoreActions.ui.setUIPreviewVisible({ value: store.getState().uiModule.tempUiPreview }));
	}, document);

	return null;
}